function t(label, lower) {
  let val = this.$vuetify.lang.t(`$vuetify.${label}`);

  if (lower) {
    val = val.toLowerCase();
  }

  return val;
}

function t2(val) {
  if (val == "Mission") {
    val = this.t("mission.title");
  } else if (val.indexOf("Mission & Value") >= 0) {
    val = val.replace(
      "Mission & Value",
      `${this.t("mission.title")} & ${this.t("core_values.title_short_s")}`
    );
  } else if (val.indexOf("mission") >= 0) {
    val = val.replace("mission", this.t("mission.title", true));
  } else if (val == "Core Values") {
    val = this.t("core_values.title");
  } else if (val.indexOf("core values") >= 0) {
    val = val.replace("core values", this.t("core_values.title", true));
  }
  return val;
}

export { t, t2 };
